import { Component, OnInit } from '@angular/core';
import { ProviderService } from '../services/providers/provider.service';
import { Provider } from '../classes/provider';
import { PriorityService } from '../services/priorities/priority.service';
import { Auth } from '../services/auth.service';
var Promise = require('bluebird');

@Component({
  selector: 'provider-logo-priority',
  templateUrl: './provider-logo-priority.component.html',
  styleUrls: ['./provider-logo-priority.component.css']
})
export class ProviderLogoPriorityComponent implements OnInit {
  providers: any[];
  providersWithoutPriority: Provider[];
  prioritizedProviders: Provider[];
  hasSysOpsPermission: Boolean = false;

  constructor(protected providerService: ProviderService,
    protected priorityService: PriorityService,
    protected auth: Auth) { }

  ngOnInit() {
    this.hasSysOpsPermission = this.auth.hasSysOpsPermission();
    let promiseNotPrioritizedProviders = this.providerService.getWithoutPriority()
    let promisePrioritizedProviders = this.providerService.getWithPriority()
    return Promise.all([promiseNotPrioritizedProviders, promisePrioritizedProviders]).spread((notPrioritizedProviders, prioritizedProviders) => {
      this.providersWithoutPriority = notPrioritizedProviders
      this.prioritizedProviders = prioritizedProviders
    })
  }

  move(provider: Provider) {
    var newIndex = this.prioritizedProviders.length
    this.providerService.update({ id: provider.id, registrationPriority: newIndex }).then(() => {
      let oldIndex = this.providersWithoutPriority.indexOf(provider)
      this.prioritizedProviders.push(provider)
      this.providersWithoutPriority.splice(oldIndex, 1);
    })
  }

  movePriority(to, provider, index) {
    return this.providerService.movePriority(provider.id, to).then((response) => {
      let newPos = index - to
      this.prioritizedProviders.splice(index, 1)
      if (newPos < 0) {
        newPos = 0
      }
      else if (newPos >= this.prioritizedProviders.length) {
        newPos = this.prioritizedProviders.length
      }
      this.prioritizedProviders.splice(newPos, 0, provider)
    })
  }

  remove(provider: Provider) {
    this.providerService.removePriority(provider.id).then(() => {
      let index = this.prioritizedProviders.indexOf(provider)
      this.providersWithoutPriority.push(provider)
      this.prioritizedProviders.splice(index, 1)
    })
  }
}



// WEBPACK FOOTER //
// ./src/app/provider-logo-priority/provider-logo-priority.component.ts